// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Templates CSS Styles
 * Styling per la gestione WhatsApp Templates
 */

.templates-container {
    padding: 2rem;
    max-width: 1400px;
    margin: 0 auto;
}

/* Header */
.templates-header {
    margin-bottom: 2rem;
}

.templates-header h1 {
    font-size: 1.75rem;
    font-weight: 700;
    color: #1a1a2e;
    margin-bottom: 0.5rem;
}

.templates-subtitle {
    color: #666;
    font-size: 0.95rem;
}

/* Stats Cards */
.templates-stats {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 1rem;
    margin-bottom: 2rem;
}

.stat-card {
    background: white;
    border-radius: 12px;
    padding: 1.25rem;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transition: transform 0.2s ease;
}

.stat-card:hover {
    transform: translateY(-2px);
}

.stat-number {
    display: block;
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 0.25rem;
}

.stat-label {
    color: #666;
    font-size: 0.85rem;
}

.stat-card.total .stat-number {
    color: #1a1a2e;
}

.stat-card.approved .stat-number {
    color: #25D366;
}

.stat-card.pending .stat-number {
    color: #f59e0b;
}

.stat-card.rejected .stat-number {
    color: #ef4444;
}

/* Tabs */
.templates-tabs {
    display: flex;
    gap: 0.5rem;
    border-bottom: 2px solid #e5e7eb;
    margin-bottom: 1.5rem;
}

.tab-btn {
    padding: 0.75rem 1.5rem;
    background: none;
    border: none;
    font-size: 0.95rem;
    color: #666;
    cursor: pointer;
    position: relative;
    transition: color 0.2s;
}

.tab-btn:hover {
    color: #25D366;
}

.tab-btn.active {
    color: #25D366;
    font-weight: 600;
}

.tab-btn.active::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    right: 0;
    height: 2px;
    background: #25D366;
}

/* Actions Bar */
.templates-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
    flex-wrap: wrap;
    gap: 1rem;
}

.filters {
    display: flex;
    gap: 0.75rem;
}

.filter-select {
    padding: 0.5rem 1rem;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    font-size: 0.9rem;
    background: white;
    cursor: pointer;
}

.filter-select:focus {
    outline: none;
    border-color: #25D366;
}

.action-buttons {
    display: flex;
    gap: 0.75rem;
}

.btn-sync,
.btn-create {
    padding: 0.6rem 1.25rem;
    border-radius: 8px;
    font-size: 0.9rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-sync {
    background: white;
    border: 1px solid #e5e7eb;
    color: #1a1a2e;
}

.btn-sync:hover {
    background: #f9fafb;
    border-color: #25D366;
}

.btn-sync:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.btn-create {
    background: #25D366;
    border: none;
    color: white;
}

.btn-create:hover {
    background: #128C7E;
}

/* Error Banner */
.error-banner {
    background: #fef2f2;
    border: 1px solid #fecaca;
    color: #dc2626;
    padding: 1rem 1.5rem;
    border-radius: 8px;
    margin-bottom: 1.5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.error-banner button {
    background: none;
    border: none;
    font-size: 1.25rem;
    cursor: pointer;
    color: #dc2626;
}

/* Content Area */
.templates-content {
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    min-height: 400px;
}

/* Template List */
.template-list {
    padding: 1.5rem;
}

.template-list-header {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr 150px;
    padding: 0.75rem 1rem;
    background: #f9fafb;
    border-radius: 8px;
    font-weight: 600;
    color: #666;
    font-size: 0.85rem;
    margin-bottom: 0.5rem;
}

.template-item {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr 150px;
    align-items: center;
    padding: 1rem;
    border-bottom: 1px solid #f3f4f6;
    transition: background 0.2s;
}

.template-item:hover {
    background: #f9fafb;
}

.template-name {
    font-weight: 600;
    color: #1a1a2e;
}

.template-name span {
    display: block;
    font-weight: 400;
    font-size: 0.8rem;
    color: #666;
    margin-top: 0.25rem;
}

.status-badge {
    display: inline-flex;
    align-items: center;
    padding: 0.25rem 0.75rem;
    border-radius: 20px;
    font-size: 0.8rem;
    font-weight: 500;
}

.status-badge.approved {
    background: #dcfce7;
    color: #16a34a;
}

.status-badge.pending {
    background: #fef3c7;
    color: #d97706;
}

.status-badge.rejected {
    background: #fee2e2;
    color: #dc2626;
}

.category-badge {
    font-size: 0.85rem;
    color: #666;
}

.template-actions {
    display: flex;
    gap: 0.5rem;
}

.template-actions button {
    padding: 0.4rem 0.75rem;
    border-radius: 6px;
    font-size: 0.8rem;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-send {
    background: #25D366;
    border: none;
    color: white;
}

.btn-send:hover {
    background: #128C7E;
}

.btn-send:disabled {
    background: #ccc;
    cursor: not-allowed;
}

.btn-preview {
    background: #f3f4f6;
    border: 1px solid #e5e7eb;
    color: #1a1a2e;
}

.btn-preview:hover {
    background: #e5e7eb;
}

.btn-delete {
    background: #fee2e2;
    border: 1px solid #fecaca;
    color: #dc2626;
}

.btn-delete:hover {
    background: #fecaca;
}

/* Empty State */
.empty-state {
    text-align: center;
    padding: 4rem 2rem;
    color: #666;
}

.empty-state .icon {
    font-size: 4rem;
    margin-bottom: 1rem;
}

.empty-state h3 {
    font-size: 1.25rem;
    color: #1a1a2e;
    margin-bottom: 0.5rem;
}

/* Loading State */
.loading-state {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4rem;
}

.spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #f3f4f6;
    border-top-color: #25D366;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

/* Modal Styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 1rem;
}

.modal-content {
    background: white;
    border-radius: 16px;
    width: 100%;
    max-width: 600px;
    max-height: 90vh;
    overflow-y: auto;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem;
    border-bottom: 1px solid #e5e7eb;
}

.modal-header h2 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #1a1a2e;
}

.modal-close {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: #666;
}

.modal-body {
    padding: 1.5rem;
}

.modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    padding: 1.5rem;
    border-top: 1px solid #e5e7eb;
}

/* Form Styles */
.form-group {
    margin-bottom: 1.25rem;
}

.form-group label {
    display: block;
    font-weight: 500;
    margin-bottom: 0.5rem;
    color: #1a1a2e;
}

.form-group input,
.form-group select,
.form-group textarea {
    width: 100%;
    padding: 0.75rem 1rem;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    font-size: 0.95rem;
    transition: border-color 0.2s;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
    outline: none;
    border-color: #25D366;
}

.form-group textarea {
    resize: vertical;
    min-height: 100px;
}

.form-group .hint {
    font-size: 0.8rem;
    color: #666;
    margin-top: 0.25rem;
}

.form-group .error {
    font-size: 0.8rem;
    color: #dc2626;
    margin-top: 0.25rem;
}

/* WhatsApp Preview Phone */
.whatsapp-preview {
    background: #E5DDD5;
    border-radius: 12px;
    padding: 1.5rem;
    max-width: 350px;
    margin: 0 auto;
}

.whatsapp-message {
    background: white;
    border-radius: 8px;
    padding: 0.75rem;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.whatsapp-message .header {
    font-weight: 600;
    margin-bottom: 0.5rem;
    color: #1a1a2e;
}

.whatsapp-message .body {
    color: #333;
    line-height: 1.5;
    white-space: pre-wrap;
}

.whatsapp-message .footer {
    font-size: 0.8rem;
    color: #666;
    margin-top: 0.5rem;
}

.whatsapp-message .buttons {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-top: 0.75rem;
    padding-top: 0.75rem;
    border-top: 1px solid #e5e7eb;
}

.whatsapp-message .buttons button {
    padding: 0.6rem;
    background: #f3f4f6;
    border: none;
    border-radius: 6px;
    color: #25D366;
    font-weight: 500;
    cursor: default;
}

/* Scheduled Templates */
.scheduled-list {
    padding: 1.5rem;
}

.scheduled-item {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr 100px;
    align-items: center;
    padding: 1rem;
    border-bottom: 1px solid #f3f4f6;
}

.scheduled-time {
    font-weight: 500;
    color: #1a1a2e;
}

.scheduled-time span {
    display: block;
    font-weight: 400;
    font-size: 0.8rem;
    color: #666;
}

/* History */
.history-list {
    padding: 1.5rem;
}

.history-item {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
    align-items: center;
    padding: 1rem;
    border-bottom: 1px solid #f3f4f6;
}

.history-status {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.history-status .icon {
    font-size: 1rem;
}

.history-status.sent .icon {
    color: #3b82f6;
}

.history-status.delivered .icon {
    color: #10b981;
}

.history-status.read .icon {
    color: #25D366;
}

.history-status.failed .icon {
    color: #ef4444;
}

/* Responsive */
@media (max-width: 768px) {
    .templates-container {
        padding: 1rem;
    }

    .templates-stats {
        grid-template-columns: repeat(2, 1fr);
    }

    .templates-actions {
        flex-direction: column;
    }

    .filters {
        width: 100%;
    }

    .filter-select {
        flex: 1 1;
    }

    .action-buttons {
        width: 100%;
    }

    .action-buttons button {
        flex: 1 1;
    }

    .template-list-header {
        display: none;
    }

    .template-item {
        grid-template-columns: 1fr;
        gap: 0.75rem;
    }

    .template-actions {
        justify-content: flex-start;
    }

    .scheduled-item,
    .history-item {
        grid-template-columns: 1fr;
        gap: 0.75rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Templates.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;IACI,aAAa;IACb,iBAAiB;IACjB,cAAc;AAClB;;AAEA,WAAW;AACX;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,yCAAyC;IACzC,+BAA+B;AACnC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,SAAS;AACT;IACI,aAAa;IACb,WAAW;IACX,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,WAAW;IACX,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;;IAEI,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,iBAAiB;AACrB;;AAEA,kBAAkB;AAClB;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,4CAA4C;IAC5C,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,4CAA4C;IAC5C,mBAAmB;IACnB,aAAa;IACb,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,wBAAwB;IACxB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,qBAAqB;AACzB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,6BAA6B;AACjC;;AAEA,gBAAgB;AAChB;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;;;IAGI,WAAW;IACX,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;;;IAGI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA,2BAA2B;AAC3B;IACI,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA,wBAAwB;AACxB;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,4CAA4C;IAC5C,mBAAmB;IACnB,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;;AAEA,YAAY;AACZ;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,eAAe;AACf;IACI;QACI,aAAa;IACjB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,SAAO;IACX;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,SAAO;IACX;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;QAC1B,YAAY;IAChB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;;QAEI,0BAA0B;QAC1B,YAAY;IAChB;AACJ","sourcesContent":["/**\n * Templates CSS Styles\n * Styling per la gestione WhatsApp Templates\n */\n\n.templates-container {\n    padding: 2rem;\n    max-width: 1400px;\n    margin: 0 auto;\n}\n\n/* Header */\n.templates-header {\n    margin-bottom: 2rem;\n}\n\n.templates-header h1 {\n    font-size: 1.75rem;\n    font-weight: 700;\n    color: #1a1a2e;\n    margin-bottom: 0.5rem;\n}\n\n.templates-subtitle {\n    color: #666;\n    font-size: 0.95rem;\n}\n\n/* Stats Cards */\n.templates-stats {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n    gap: 1rem;\n    margin-bottom: 2rem;\n}\n\n.stat-card {\n    background: white;\n    border-radius: 12px;\n    padding: 1.25rem;\n    text-align: center;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n    transition: transform 0.2s ease;\n}\n\n.stat-card:hover {\n    transform: translateY(-2px);\n}\n\n.stat-number {\n    display: block;\n    font-size: 2rem;\n    font-weight: 700;\n    margin-bottom: 0.25rem;\n}\n\n.stat-label {\n    color: #666;\n    font-size: 0.85rem;\n}\n\n.stat-card.total .stat-number {\n    color: #1a1a2e;\n}\n\n.stat-card.approved .stat-number {\n    color: #25D366;\n}\n\n.stat-card.pending .stat-number {\n    color: #f59e0b;\n}\n\n.stat-card.rejected .stat-number {\n    color: #ef4444;\n}\n\n/* Tabs */\n.templates-tabs {\n    display: flex;\n    gap: 0.5rem;\n    border-bottom: 2px solid #e5e7eb;\n    margin-bottom: 1.5rem;\n}\n\n.tab-btn {\n    padding: 0.75rem 1.5rem;\n    background: none;\n    border: none;\n    font-size: 0.95rem;\n    color: #666;\n    cursor: pointer;\n    position: relative;\n    transition: color 0.2s;\n}\n\n.tab-btn:hover {\n    color: #25D366;\n}\n\n.tab-btn.active {\n    color: #25D366;\n    font-weight: 600;\n}\n\n.tab-btn.active::after {\n    content: '';\n    position: absolute;\n    bottom: -2px;\n    left: 0;\n    right: 0;\n    height: 2px;\n    background: #25D366;\n}\n\n/* Actions Bar */\n.templates-actions {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1.5rem;\n    flex-wrap: wrap;\n    gap: 1rem;\n}\n\n.filters {\n    display: flex;\n    gap: 0.75rem;\n}\n\n.filter-select {\n    padding: 0.5rem 1rem;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    font-size: 0.9rem;\n    background: white;\n    cursor: pointer;\n}\n\n.filter-select:focus {\n    outline: none;\n    border-color: #25D366;\n}\n\n.action-buttons {\n    display: flex;\n    gap: 0.75rem;\n}\n\n.btn-sync,\n.btn-create {\n    padding: 0.6rem 1.25rem;\n    border-radius: 8px;\n    font-size: 0.9rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.btn-sync {\n    background: white;\n    border: 1px solid #e5e7eb;\n    color: #1a1a2e;\n}\n\n.btn-sync:hover {\n    background: #f9fafb;\n    border-color: #25D366;\n}\n\n.btn-sync:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.btn-create {\n    background: #25D366;\n    border: none;\n    color: white;\n}\n\n.btn-create:hover {\n    background: #128C7E;\n}\n\n/* Error Banner */\n.error-banner {\n    background: #fef2f2;\n    border: 1px solid #fecaca;\n    color: #dc2626;\n    padding: 1rem 1.5rem;\n    border-radius: 8px;\n    margin-bottom: 1.5rem;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.error-banner button {\n    background: none;\n    border: none;\n    font-size: 1.25rem;\n    cursor: pointer;\n    color: #dc2626;\n}\n\n/* Content Area */\n.templates-content {\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n    min-height: 400px;\n}\n\n/* Template List */\n.template-list {\n    padding: 1.5rem;\n}\n\n.template-list-header {\n    display: grid;\n    grid-template-columns: 2fr 1fr 1fr 1fr 150px;\n    padding: 0.75rem 1rem;\n    background: #f9fafb;\n    border-radius: 8px;\n    font-weight: 600;\n    color: #666;\n    font-size: 0.85rem;\n    margin-bottom: 0.5rem;\n}\n\n.template-item {\n    display: grid;\n    grid-template-columns: 2fr 1fr 1fr 1fr 150px;\n    align-items: center;\n    padding: 1rem;\n    border-bottom: 1px solid #f3f4f6;\n    transition: background 0.2s;\n}\n\n.template-item:hover {\n    background: #f9fafb;\n}\n\n.template-name {\n    font-weight: 600;\n    color: #1a1a2e;\n}\n\n.template-name span {\n    display: block;\n    font-weight: 400;\n    font-size: 0.8rem;\n    color: #666;\n    margin-top: 0.25rem;\n}\n\n.status-badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 0.25rem 0.75rem;\n    border-radius: 20px;\n    font-size: 0.8rem;\n    font-weight: 500;\n}\n\n.status-badge.approved {\n    background: #dcfce7;\n    color: #16a34a;\n}\n\n.status-badge.pending {\n    background: #fef3c7;\n    color: #d97706;\n}\n\n.status-badge.rejected {\n    background: #fee2e2;\n    color: #dc2626;\n}\n\n.category-badge {\n    font-size: 0.85rem;\n    color: #666;\n}\n\n.template-actions {\n    display: flex;\n    gap: 0.5rem;\n}\n\n.template-actions button {\n    padding: 0.4rem 0.75rem;\n    border-radius: 6px;\n    font-size: 0.8rem;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.btn-send {\n    background: #25D366;\n    border: none;\n    color: white;\n}\n\n.btn-send:hover {\n    background: #128C7E;\n}\n\n.btn-send:disabled {\n    background: #ccc;\n    cursor: not-allowed;\n}\n\n.btn-preview {\n    background: #f3f4f6;\n    border: 1px solid #e5e7eb;\n    color: #1a1a2e;\n}\n\n.btn-preview:hover {\n    background: #e5e7eb;\n}\n\n.btn-delete {\n    background: #fee2e2;\n    border: 1px solid #fecaca;\n    color: #dc2626;\n}\n\n.btn-delete:hover {\n    background: #fecaca;\n}\n\n/* Empty State */\n.empty-state {\n    text-align: center;\n    padding: 4rem 2rem;\n    color: #666;\n}\n\n.empty-state .icon {\n    font-size: 4rem;\n    margin-bottom: 1rem;\n}\n\n.empty-state h3 {\n    font-size: 1.25rem;\n    color: #1a1a2e;\n    margin-bottom: 0.5rem;\n}\n\n/* Loading State */\n.loading-state {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 4rem;\n}\n\n.spinner {\n    width: 40px;\n    height: 40px;\n    border: 3px solid #f3f4f6;\n    border-top-color: #25D366;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* Modal Styles */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    padding: 1rem;\n}\n\n.modal-content {\n    background: white;\n    border-radius: 16px;\n    width: 100%;\n    max-width: 600px;\n    max-height: 90vh;\n    overflow-y: auto;\n}\n\n.modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1.5rem;\n    border-bottom: 1px solid #e5e7eb;\n}\n\n.modal-header h2 {\n    font-size: 1.25rem;\n    font-weight: 600;\n    color: #1a1a2e;\n}\n\n.modal-close {\n    background: none;\n    border: none;\n    font-size: 1.5rem;\n    cursor: pointer;\n    color: #666;\n}\n\n.modal-body {\n    padding: 1.5rem;\n}\n\n.modal-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.75rem;\n    padding: 1.5rem;\n    border-top: 1px solid #e5e7eb;\n}\n\n/* Form Styles */\n.form-group {\n    margin-bottom: 1.25rem;\n}\n\n.form-group label {\n    display: block;\n    font-weight: 500;\n    margin-bottom: 0.5rem;\n    color: #1a1a2e;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n    width: 100%;\n    padding: 0.75rem 1rem;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    font-size: 0.95rem;\n    transition: border-color 0.2s;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n    outline: none;\n    border-color: #25D366;\n}\n\n.form-group textarea {\n    resize: vertical;\n    min-height: 100px;\n}\n\n.form-group .hint {\n    font-size: 0.8rem;\n    color: #666;\n    margin-top: 0.25rem;\n}\n\n.form-group .error {\n    font-size: 0.8rem;\n    color: #dc2626;\n    margin-top: 0.25rem;\n}\n\n/* WhatsApp Preview Phone */\n.whatsapp-preview {\n    background: #E5DDD5;\n    border-radius: 12px;\n    padding: 1.5rem;\n    max-width: 350px;\n    margin: 0 auto;\n}\n\n.whatsapp-message {\n    background: white;\n    border-radius: 8px;\n    padding: 0.75rem;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.whatsapp-message .header {\n    font-weight: 600;\n    margin-bottom: 0.5rem;\n    color: #1a1a2e;\n}\n\n.whatsapp-message .body {\n    color: #333;\n    line-height: 1.5;\n    white-space: pre-wrap;\n}\n\n.whatsapp-message .footer {\n    font-size: 0.8rem;\n    color: #666;\n    margin-top: 0.5rem;\n}\n\n.whatsapp-message .buttons {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    margin-top: 0.75rem;\n    padding-top: 0.75rem;\n    border-top: 1px solid #e5e7eb;\n}\n\n.whatsapp-message .buttons button {\n    padding: 0.6rem;\n    background: #f3f4f6;\n    border: none;\n    border-radius: 6px;\n    color: #25D366;\n    font-weight: 500;\n    cursor: default;\n}\n\n/* Scheduled Templates */\n.scheduled-list {\n    padding: 1.5rem;\n}\n\n.scheduled-item {\n    display: grid;\n    grid-template-columns: 2fr 1fr 1fr 1fr 100px;\n    align-items: center;\n    padding: 1rem;\n    border-bottom: 1px solid #f3f4f6;\n}\n\n.scheduled-time {\n    font-weight: 500;\n    color: #1a1a2e;\n}\n\n.scheduled-time span {\n    display: block;\n    font-weight: 400;\n    font-size: 0.8rem;\n    color: #666;\n}\n\n/* History */\n.history-list {\n    padding: 1.5rem;\n}\n\n.history-item {\n    display: grid;\n    grid-template-columns: 2fr 1fr 1fr 1fr 1fr;\n    align-items: center;\n    padding: 1rem;\n    border-bottom: 1px solid #f3f4f6;\n}\n\n.history-status {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.history-status .icon {\n    font-size: 1rem;\n}\n\n.history-status.sent .icon {\n    color: #3b82f6;\n}\n\n.history-status.delivered .icon {\n    color: #10b981;\n}\n\n.history-status.read .icon {\n    color: #25D366;\n}\n\n.history-status.failed .icon {\n    color: #ef4444;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n    .templates-container {\n        padding: 1rem;\n    }\n\n    .templates-stats {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .templates-actions {\n        flex-direction: column;\n    }\n\n    .filters {\n        width: 100%;\n    }\n\n    .filter-select {\n        flex: 1;\n    }\n\n    .action-buttons {\n        width: 100%;\n    }\n\n    .action-buttons button {\n        flex: 1;\n    }\n\n    .template-list-header {\n        display: none;\n    }\n\n    .template-item {\n        grid-template-columns: 1fr;\n        gap: 0.75rem;\n    }\n\n    .template-actions {\n        justify-content: flex-start;\n    }\n\n    .scheduled-item,\n    .history-item {\n        grid-template-columns: 1fr;\n        gap: 0.75rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
